import React, { useEffect, useState } from "react";
import "./App.css";

import {
  IconButton,
  TableHead,
  Typography,
  Table,
  TableContainer,
  Paper,
  TableRow,
} from "@material-ui/core";
import UserValueDialog from "./UserValueDialog";
import DeleteConfirmDialog from "./DeleteConfirmDialog";

import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import {
  LoadPaper,
  PaperTitle,
  PrimaryButton,
  SecondaryButton,
  HeaderTitle,
  DarkBlue,
  DarkRed,
  TableCellTadpole,
  TableCellContent,
  CopyButton,
  DeleteAllButton,
} from "./styles";



const VARIABLES_KEY = "variables";

interface Variable {
  name: string;
  values: string[];
}

interface VariableWithColumn extends Variable {
  column: string[];
}

interface IValueLocation {
  variableIndex: number;
  valueIndex: number;
}

function combinations(variables: Variable[]): VariableWithColumn[] {
  const itemsWithCols = variables.map((i) => ({
    ...i,
    column: [] as string[],
  }));
  const numCols = variables.reduce((a, b) => a * b.values.length, 1);

  let repeatCount = 1;
  for (let i = variables.length - 1; i >= 0; i--) {
    let totalCount = 0;
    let valueIdx = 0;

    while (totalCount < numCols) {
      let count = 0;
      while (count < repeatCount) {
        itemsWithCols[i].column.push(
          itemsWithCols[i].values[valueIdx % itemsWithCols[i].values.length]
        );
        count += 1;
      }
      valueIdx += 1;
      totalCount += count;
    }
    repeatCount = repeatCount * itemsWithCols[i].values.length;
  }
  return itemsWithCols;
}

function getCsv(variables: VariableWithColumn[]): string {
  let res = variables.map((item) => item.name).join(",") + "\n";
  for (let i = 0; i < variables[0].column.length; i++) {
    res += variables.map((item) => item.column[i]).join(",") + "\n";
  }
  return res;
}

function App() {
  const [variableToDelete, setVariableToDelete] = useState<number | undefined>(
    undefined
  );

  const [deleteAllVariables, setDeleteAllVariables] = useState<boolean>(false);

  const [valueToDelete, setValueToDelete] = useState<
    IValueLocation | undefined
  >(undefined);

  const [variables, setVariables] = useState<Variable[]>([]);

  const [newVariableOpen, setNewVariableOpen] = useState<boolean>(false);

  const [variableToAddValueTo, setVariableToAddValueTo] = useState<
    Variable | undefined
  >(undefined);

  const [variableIndexToEdit, setVariableIndexToEdit] = useState<
    number | undefined
  >(undefined);

  const [valueToEdit, setValueToEdit] = useState<IValueLocation | undefined>(
    undefined
  );

  async function loadItems() {
    const s = localStorage.getItem(VARIABLES_KEY) || "[]";
    setVariables(JSON.parse(s));
  }

  useEffect(() => {
    loadItems();
  }, []);

  const variablesWithColumns = combinations(
    variables.filter((v: Variable) => v.values.length > 0)
  );

  console.log(variablesWithColumns);

  function getCopyButton() {
    if (variables.length > 0) {
      return (
        <CopyButton
          style={{}}
          onClick={() => {
            let text = getCsv(variablesWithColumns);
            navigator.clipboard.writeText(text).then(
              function () {
                console.log("Async: Copying to clipboard was successful!");
              },
              function (err) {
                console.error("Async: Could not copy text: ", err);
              }
            );
          }}
        >
          {<FileCopyIcon style={{ marginRight: 3 }} />}Copy To Clipboard
        </CopyButton>
      );
    } else {
      return null;
    }
  }
  return (
    <div style={{ marginLeft: 20, marginTop: 20, marginRight: 20 }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <HeaderTitle style={{ marginRight: 10 }}>VARIABLES:</HeaderTitle>
        <PrimaryButton
          style={{ marginRight: 10 }}
          variant="contained"
          onClick={() => setNewVariableOpen(true)}
        >
          {<AddIcon style={{ marginRight: 5 }} />} New Variable
        </PrimaryButton>

        <DeleteAllButton
          onClick={async (event) => {
            setDeleteAllVariables(true);
          }}
        >
          Delete All
        </DeleteAllButton>
      </div>

      {variables.length === 0 && (
        <Typography style={{ fontSize: 20, marginLeft: 20, marginTop: 15 }}>
          You have no variables. Add new variable!
        </Typography>
      )}

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          columnGap: 10,
          flexWrap: "wrap",
          height: "100%",
        }}
      >
        {variables.map((variable, idx) => (
          <LoadPaper>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "auto, auto",
                alignItems: "center",
              }}
            >
              <PaperTitle
                style={{
                  gridColumn: "1",
                  borderBottomStyle: "solid",
                  borderBottomColor: "#e7e4e4",
                }}
              >
                {variable.name}{" "}
              </PaperTitle>

              <div
                style={{
                  gridColumn: "2",
                  borderBottomStyle: "solid",
                  borderBottomColor: "#e7e4e4",
                }}
              >
                <IconButton
                  onClick={() => {
                    console.log(idx);
                    setVariableIndexToEdit(idx);
                  }}
                >
                  <EditIcon
                    style={{
                      width: 15,
                      height: 15,
                      color: DarkBlue,
                    }}
                  />
                </IconButton>
                <IconButton
                  onClick={async (event) => {
                    setVariableToDelete(idx);
                  }}
                >
                  <DeleteIcon
                    style={{
                      width: 15,
                      height: 15,
                      color: DarkRed,
                    }}
                  />
                </IconButton>
              </div>

              {variable.values.map((v, valueIndex) => (
                <>
                  <Typography
                    style={{
                      gridColumn: "1",
                    }}
                  >
                    {v}
                  </Typography>
                  <div style={{ gridColumn: "2" }}>
                    <IconButton
                      onClick={() => {
                        setValueToEdit({
                          variableIndex: idx,
                          valueIndex: valueIndex,
                        });
                      }}
                    >
                      <EditIcon
                        style={{
                          width: 15,
                          height: 15,

                          color: DarkBlue,
                        }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={async (event) => {
                        setValueToDelete({
                          variableIndex: idx,
                          valueIndex: valueIndex,
                        });
                      }}
                    >
                      <DeleteIcon
                        style={{
                          width: 15,
                          height: 15,
                          color: DarkRed,
                        }}
                      />
                    </IconButton>
                  </div>
                </>
              ))}
            </div>
            <div>
              <SecondaryButton
                style={{ marginTop: 10 }}
                onClick={() => {
                  setVariableToAddValueTo(variable);
                }}
              >
                {<AddIcon style={{ marginRight: 5 }} />} Add Value
              </SecondaryButton>
            </div>
          </LoadPaper>
        ))}
      </div>

      {/*  dialog to confirm value delete */}
      {valueToDelete !== undefined && (
        <DeleteConfirmDialog
          open={valueToDelete !== undefined}
          close={() => setValueToDelete(undefined)}
          save={() => {
            variables[valueToDelete.variableIndex].values.splice(
              valueToDelete.valueIndex,
              1
            );
            // 1. save to disk
            localStorage.setItem(VARIABLES_KEY, JSON.stringify(variables));
            // 2. refresh from disk
            loadItems();
          }}
        />
      )}

      {/*  dialog to confirm variable delete */}
      {variableToDelete !== undefined && (
        <DeleteConfirmDialog
          open={variableToDelete !== undefined}
          close={() => setVariableToDelete(undefined)}
          save={() => {
            variables.splice(variableToDelete, 1);
            localStorage.setItem(VARIABLES_KEY, JSON.stringify(variables));
            // 1. save to disk

            // 2. refresh from disk
            loadItems();
          }}
        />
      )}
      {/*  dialog to confirm deleting all variables */}
      {deleteAllVariables && (
        <DeleteConfirmDialog
          open={deleteAllVariables}
          close={() => setDeleteAllVariables(false)}
          save={() => {
            localStorage.removeItem(VARIABLES_KEY);

            // 2. refresh from disk
            loadItems();
          }}
        />
      )}

      {/*  dialog to create a card/variable */}
      {newVariableOpen && (
        <UserValueDialog
          open={newVariableOpen}
          save={(s: string) => {
            // 1. save to disk
            const newVariables = [...variables, { name: s, values: [] }];
            localStorage.setItem(VARIABLES_KEY, JSON.stringify(newVariables));
            // 2. refresh from disk
            loadItems();
          }}
          close={() => setNewVariableOpen(false)}
        />
      )}
      {/*  dialog to add card values */}
      {variableToAddValueTo !== undefined && (
        <UserValueDialog
          open={variableToAddValueTo !== undefined}
          close={() => {
            setVariableToAddValueTo(undefined);
          }}
          save={(s: string) => {
            variableToAddValueTo.values.push(s);
            const newVariables = [...variables];
            localStorage.setItem(VARIABLES_KEY, JSON.stringify(newVariables));
            loadItems();
          }}
        />
      )}
      {/*  dialog to edit card names */}
      {variableIndexToEdit !== undefined && (
        <UserValueDialog
          open={variableIndexToEdit !== undefined}
          close={() => {
            setVariableIndexToEdit(undefined);
          }}
          initalText={variables[variableIndexToEdit].name}
          save={(s: string) => {
            variables[variableIndexToEdit].name = s;
            localStorage.setItem(VARIABLES_KEY, JSON.stringify(variables));
            loadItems();
          }}
        />
      )}
      {/*  dialog to edit card values */}
      {valueToEdit !== undefined && (
        <UserValueDialog
          open={valueToEdit !== undefined}
          close={() => {
            setValueToEdit(undefined);
          }}
          initalText={
            variables[valueToEdit.variableIndex].values[valueToEdit.valueIndex]
          }
          save={(s: string) => {
            variables[valueToEdit.variableIndex].values[
              valueToEdit.valueIndex
            ] = s;
            console.log("lion", valueToEdit);
            localStorage.setItem(VARIABLES_KEY, JSON.stringify(variables));
            loadItems();
          }}
        />
      )}

      <div
        style={{
          height: "100%",
          marginBottom: 0,
        }}
      >
        <div
          style={{
            float: "right",
            marginBottom: 1,
            marginRight: 5,
          }}
        >
          {getCopyButton()}
        </div>

        <div>
          <TableContainer style={{ marginTop: 40 }} component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  {console.log(variablesWithColumns)}
                  {variablesWithColumns.map((v) => (
                    <TableCellTadpole>{v.name}</TableCellTadpole>
                  ))}
                </TableRow>
              </TableHead>
              {(variablesWithColumns[0]?.column || []).map((_, idx) => (
                <TableRow>
                  {variablesWithColumns.map((v) => (
                    <TableCellContent>{v.column[idx]}</TableCellContent>
                  ))}
                </TableRow>
              ))}
            </Table>
          </TableContainer>
        </div>

        {variables.length > 0 && (
          <PrimaryButton
            style={{ marginBottom: 30, marginTop: 10 }}
            variant="contained"
            onClick={() => {
              var link = document.createElement("a");
              link.download = "tadpole.csv";
              var blob = new Blob([getCsv(variablesWithColumns)], {
                type: "text/plain",
              });
              link.href = window.URL.createObjectURL(blob);
              link.click();
            }}
          >
            Download CSV
          </PrimaryButton>
        )}
      </div>
    </div>
  );
}

export default App;
